import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import homeIcon from "../Assets/images/icons/icon-home.png";
import productIcon from "../Assets/images/icons/icon-product.png";
import usersIcon from "../Assets/images/icons/icon-users.png";
import bannerIcon from "../Assets/images/icons/icon-banner.png";
import '../Assets/css/--layout.css'
export default function Navigation() {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleSubMenu = (label) => {
    setOpenMenu(openMenu === label ? null : label);
  };

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: homeIcon },
    {
      label: 'Product Management',
      icon: productIcon,
      children: [
        { path: '/products', label: 'Match Products' },
        { path: '/products/amazon', label: 'Amazon Products' },
        { path: '/products/carrefour', label: 'Carrefour Products' },
      ]
    },
    { path: '/scraper', label: 'Scraper', icon: productIcon },
    { path: '/users', label: 'User Management', icon: usersIcon },
    { path: '/categories', label: 'Categories', icon: bannerIcon },
    {
      label: 'Banner Management',
      icon: bannerIcon,
      children: [
        { path: '/banners', label: 'All Banner' },
        { path: '/banners/add', label: 'Add Banner' },
      ]
    },
  ];

  return (
    <nav className="sidebar-nav">
      <ul>
        {navItems.map(({ path, label, icon, children }) => (
          <li key={label}>
            {children ? (
              <>
                <div
                  className="sidebar-link"
                  onClick={() => toggleSubMenu(label)}
                  style={{ cursor: 'pointer' }}
                >
                  <img className="sidebar-icon" src={icon} alt={label} />
                  <span>{label}</span>
                </div>
                {openMenu === label && (
                  <ul className="submenu">
                    {children.map((child) => (
                      <li key={child.path}>
                        <NavLink to={child.path} className="sidebar-sublink">
                          <i className="ri-circle-line fs-10 me-2"></i>
                          {child.label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </>
            ) : (
              <NavLink to={path} className="sidebar-link">
                <img className="sidebar-icon" src={icon} alt={label} />
                <span>{label}</span>
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}